// Keep a synchronous fallback for HTTP installations and browsers that deny Clipboard API access.
export async function copyTextToClipboard(text, sourceInput) {
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // The browser may still permit copying a selected input after denying the API.
  }
  const input = sourceInput || document.createElement('textarea');
  const previousFocus = document.activeElement;
  if (!sourceInput) {
    input.value = text;
    input.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(input);
  }
  input.focus();
  input.select();
  input.setSelectionRange(0, text.length);
  let copied = false;
  try {
    copied = document.execCommand?.('copy') === true;
  } catch {
    copied = false;
  } finally {
    if (!sourceInput) input.remove();
    if (copied || !sourceInput) previousFocus?.focus();
  }
  return copied;
}
